import WatchIcon from "@atlaskit/icon/glyph/watch";
import WatchFilledIcon from "@atlaskit/icon/glyph/watch-filled";
import axios from "axios";
import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import googleIcon from ".././assets/images/g-normal.png";
import microsoftIcon from ".././assets/images/microsoft-avatar.png";
import AktButton from "../AtlaskitControls/AtkButton";
import AtkLoader from "../AtlaskitControls/AtkLoader";
import AktTextField from "../AtlaskitControls/AtkTextField";
import nowcertsIcon from "../assets/images/nc.png";
import Footer from "../common/Footer";
import Header from "../common/Header";
import CommonValues from "../common/utils";

interface IProps {}

const Login: FC<IProps> = () => {
  const navigate = useNavigate();
  const [LeadGenUserName, setName] = useState("");
  const [LeadGenPassword, setPassword] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [UserError, setUserError] = useState("");
  const [SlugURL, setURL] = useState("");
  const [loading, setLoading] = useState(false);
  const [socialLoading, setSocialLoading] = useState(false);
  const [echoLoading, setEchoLoading] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  let currentMsg = 0;
  const location = useLocation();

  useEffect(() => {
    let query = new URLSearchParams(window.location.hash);
    if (query != null && query != undefined) {
      var access_token = query.get("#access_token");
      var error_msg = query.get("error_description");

      if (error_msg != "" && error_msg != null && error_msg != undefined) {
        navigate("/");
      }

      if (
        access_token != "" &&
        access_token != null &&
        access_token != undefined
      ) {
        setSocialLoading(true);
        localStorage.setItem("st", access_token);
        var config = {
          method: "post",
          url: `${process.env.REACT_APP_AUTHAPI}/validateSocialLogin?`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        };
        axios(config)
          .then((response: any) => {
            localStorage.setItem("SocialLogin", "true");
            if (response.data.token == "") {
              setPasswordError("Not registered user/ unauthorized user.");
            } else {
              localStorage.setItem("igtoken", response.data.token);
              localStorage.setItem("tenantId", response.data.tenantId);
              localStorage.setItem("userName", response.data.userName);
              navigate("/startuppage");
            }
            setSocialLoading(false);
          })
          .catch((error: any) => {
            console.log(error);
            if (error.response.data.status == 401) {
              window.location.href =
                `${process.env.REACT_APP_UiUrl}/agencyonboarding#access_token=` +
                access_token;
              setSocialLoading(false);
              return false;
            } else if (error.response.data.status == 409) {
              setSocialLoading(false);
              navigate("/linkuser", {
                state: {
                  access_token,
                },
              });
            } else {
              console.log(error);
              setSocialLoading(false);
            }
          });
      }
    }
    //-End of Social Connection
  }, [location.hash]);

  useEffect(() => {
    let token = localStorage.getItem("igtoken");
    if (token != null) {
      localStorage.removeItem("addObject");
      var config = {
        method: "get",
        url: `${process.env.REACT_APP_AUTHAPI}/api/Echo/get`,
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
        },
      };
      setEchoLoading(true);
      axios(config)
        .then((response: any) => {
          setEchoLoading(false);
          navigate("/startuppage");
        })
        .catch((error: any) => {
          setEchoLoading(false);
          console.log(error);
          if (error.response.data.status == 401) {
            navigate("/");
            CommonValues.Logout(navigate);
          } else {
            alert("Error while processing the request.");
          }
        });
    }
  }, [currentMsg]);

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    setUserError("");
    setPasswordError("");

    if (LeadGenUserName.trim() == "") {
      formIsValid = false;
      setName("");
      setUserError("Please enter work email");
    } else {
    }

    if (LeadGenPassword.trim() == "") {
      formIsValid = false;
      setPasswordError("Please enter password");
    } else {
    }
    return formIsValid;
  };

  const buttonClick = () => {
    if (!handleValidation()) {
      return false;
    }

    const loginReq = {
      UserName: LeadGenUserName,
      Password: LeadGenPassword,
      SlugURL: SlugURL,
    };

    var data = JSON.stringify(loginReq);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_AUTHAPI}/login`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      data: data,
    };
    setLoading(true);
    axios(config)
      .then((response: any) => {
        if (response.data.token == "") {
          setLoading(false);
          setPasswordError("Work email or Password is incorrect.");
        } else {
          localStorage.setItem("igtoken", response.data.token);
          localStorage.setItem("tenantId", response.data.tenantId);
          localStorage.setItem("userName", response.data.userName);
          navigate("/startuppage");
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.log(error);
        if (error.response.data.status == 401) {
          setPasswordError("Work email or Password is incorrect.");
        } else {
          alert("Error while processing the request.");
        }
      });
  };

  const onCloseCLick = () => {};

  const onChangeName = (e: any) => {
    if (e.target.value.length > 255) {
      return;
    }
    setName(e.target.value);
  };

  const onChangePassword = (e: any) => {
    if (e.target.value.length > 255) {
      return;
    }
    setPassword(e.target.value);
  };

  const onKeyDown = (e: any) => {
    if (e.keyCode == 13) {
      buttonClick();
    }
  };

  const onLoginWithGoogle = () => {
    var url = window.location.href;
    window.location.href =
      process.env.REACT_APP_Auth0URL +
      "/authorize?response_type=token&client_id=" +
      process.env.REACT_APP_Auth0ClientId +
      "&connection=google-oauth2&redirect_uri=" +
      url +
      "&scope=email%20profile&prompt=login&state=login&audience=" +
      process.env.REACT_APP_Auth0URL +
      "/api/v2/";
  };

  const onLoginWithMicrosoft = () => {
    var url = window.location.href;
    window.location.href =
      process.env.REACT_APP_Auth0URL +
      "/authorize?response_type=token&client_id=" +
      process.env.REACT_APP_Auth0ClientId +
      "&connection=windowslive&redirect_uri=" +
      url +
      "&scope=email%20profile&prompt=login&state=login&audience=" +
      process.env.REACT_APP_Auth0URL +
      "/api/v2/";
  };
  const onLoginWithNowcerts = () => {
    window.open(process.env.REACT_APP_Nowcerts_Url, "_blank");
  };
  const onShowPassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  return (
    <div className="login-page">
      <Header pagename="login" />
      <div className="content-wrapper container-fluid landing-content-wrapper d-flex justify-content-center">
        <div className="login-box ">
          <div className="row mx-auto d-flex align-items-center">
            {socialLoading == true ? (
              <>
                <div className=" sso-loader mb-2">
                  <AtkLoader /> Processing ...
                </div>
              </>
            ) : (
              <>
                <div className=" col-4 text-start ">
                  <label>
                    Work Email<span className="text-danger ">*</span>{" "}
                  </label>
                </div>
                <div
                  className={
                    UserError.length > 0 ? "col-8  validation-div" : "col-8  "
                  }
                >
                  <AktTextField
                    type="text"
                    id="txtUserName"
                    name="LeadGenUserName"
                    onChange={onChangeName}
                    value={LeadGenUserName}
                    onKeyDown={onKeyDown}
                    className="input-field"
                    placeholder="Enter work email"
                  />
                  <span className="text-danger text-12 ">{UserError}</span>
                </div>
                <div className="col-4 mt-3 text-start">
                  <label>
                    Password<span className="text-danger ">*</span>{" "}
                  </label>
                </div>
                <div
                  className={
                    PasswordError.length > 0
                      ? "col-8  position-relative  validation-div mt-3"
                      : "col-8  position-relative mt-3 "
                  }
                >
                  <AktTextField
                    type={passwordType}
                    id="txtPassword"
                    name="LeadGenPassword"
                    onChange={onChangePassword}
                    value={LeadGenPassword}
                    onKeyDown={onKeyDown}
                    className="input-field"
                    placeholder="Enter password"
                  />
                  <span className="login-eye-icon" onClick={onShowPassword}>
                    {passwordType === "password" ? (
                      <WatchFilledIcon label="Pause" />
                    ) : (
                      <WatchIcon label="Play" />
                    )}
                  </span>{" "}
                  <span className="text-danger text-12 ">{PasswordError}</span>
                </div>
                <div className="col-12 text-center my-3">
                  {loading || echoLoading ? (
                    <div className="p-1">
                      <AtkLoader />{" "}
                    </div>
                  ) : (
                    <AktButton
                      label="Sign In"
                      onClick={buttonClick}
                      className="pf-primary-btn w-auto"
                    />
                  )}
                </div>
                <div className="col-6 text-end">
                  <span
                    onClick={onLoginWithGoogle}
                    className="social-link-block"
                  >
                    <span className="me-1 ">
                      <img src={googleIcon} alt="" />
                    </span>
                    <span className=" text-14 ">
                      <span>Continue with Google</span>
                    </span>
                  </span>
                </div>

                <div className="col-6 ">
                  <span
                    onClick={onLoginWithMicrosoft}
                    className="social-link-block"
                  >
                    <span className="me-1">
                      <img src={microsoftIcon} alt="" />
                    </span>
                    <span className=" text-14 ">
                      <span>Continue with Microsoft</span>
                    </span>
                  </span>
                </div>
                <div className="col-12 text-center my-3">
                  <span
                    onClick={onLoginWithNowcerts}
                    className="social-link-block"
                  >
                    <span className="me-1 ">
                      <img src={nowcertsIcon} alt="" />
                    </span>
                    <span className=" text-14 ">
                      <span>Continue with Nowcerts</span>
                    </span>
                  </span>
                </div>
                <div className="col-6 text-end ">
                  <a
                    target="_blank"
                    href={
                      process.env.REACT_APP_APPMARKETURL + "/forgotpassword"
                    }
                    className="  login-link"
                  >
                    Forgot password
                  </a>
                </div>
                <div className="col-6 ">
                  <a
                    target="_blank"
                    href={
                      process.env.REACT_APP_APPMARKETURL +
                      "/agencyonboarding?utm_source=ChromeExt"
                    }
                    className="  login-link"
                  >
                    Create an account
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Login;
